import { render, staticRenderFns } from "./EnrollmentConfirmTip.vue?vue&type=template&id=1008f4d5&scoped=true&"
import script from "./EnrollmentConfirmTip.vue?vue&type=script&lang=js&"
export * from "./EnrollmentConfirmTip.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentConfirmTip.vue?vue&type=style&index=0&id=1008f4d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008f4d5",
  null
  
)

export default component.exports